import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { postUsers, getAccountContracts, getAccountDsos, getAPIAuthorizationList } from "services/ConfigServices";
import { compte } from "variables/patrimoine.js";
import { typebyenergy, utilitytypebyenergy } from "variables/lists/authorization";
import CustomSelect from "components/Input/CustomSelect.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { optionsData, memv2versionData, usertypechangeadminData, usertypechangeadminmemData } from "variables/lists/users"
import { userpagetext } from "variables/users";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
  },
}));

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


function EditUsersDialog(props) {
  const { closeModal, refetch, users, permissionlist, viewlist } = props;
  const currentusertype = localStorage.getItem("userType");

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;



  const [usertype, setUsertype] = useState("");
  const [userpermission, setUserpermission] = useState("");
  const [userview, setUserview] = useState("");
  const [memv2version, setMemv2version] = useState("");
  const [options, setOptions] = useState([]);

  const [usertypeupdate, setUsertypeupdate] = useState(false);
  const [userviewupdate, setUserviewupdate] = useState(false);
  const [memv2versionupdate, setMemv2versionupdate] = useState(false);
  const [optionsupdate, setOptionsupdate] = useState(false);

  const handleUsertypeChange = (event) => {
    setUsertype(event.target.value);
  };

  const handlePermissionChange = (event) => {
    setUserpermission(event.target.value);
  };

  const handleUserviewChange = (event) => {
    setUserview(event.target.value);
  };

  const handleMemv2versionChange = (event) => {
    setMemv2version(event.target.value);
  };

  const handleOptionsChange = (newValue) => {
    let newArray = [];
    for (let i = 0; i < newValue.length; i++) {
      newArray.push(newValue[i]);
    }
    setOptions(newArray);
  };

  const handleUsertypeupdateChange = (event) => {
    setUsertype("");
    setUserpermission("");
    setUsertypeupdate(!usertypeupdate);
  };
  const handleUserviewupdateChange = (event) => {
    setUserview("");
    setUserviewupdate(!userviewupdate);
  };
  const handleMemv2versionupdateChange = (event) => {
    setMemv2version("");
    setMemv2versionupdate(!memv2versionupdate);
  };
  const handleOptionsupdateChange = (event) => {
    setOptions([]);
    setOptionsupdate(!optionsupdate);
  };


  const [buttonDisabled, setButtonDisabled] = useState(true);
  useEffect(() => {
    let disabled = false;
    if (!usertypeupdate && !userviewupdate && !memv2versionupdate
      && !optionsupdate)
      disabled = true;
    else {
      if (usertypeupdate && usertype.length === 0)
        disabled = true;
      if (userviewupdate && userview.length === 0)
        disabled = true;
      if (memv2versionupdate && memv2version.length === 0)
        disabled = true;
      if (optionsupdate && options.length === 0)
        disabled = true;
    }
    setButtonDisabled(disabled);
  }, [usertypeupdate,
    userviewupdate,
    memv2versionupdate,
    optionsupdate,
    usertype,
    userview,
    memv2version,
    options,
  ]);

  const handleSubmit = () => {
    updateUsers();
  };

  const updateUsers = async (event) => {
    const update = {};
    const updated = users.map((user) => {
      let updateuser = user;
      if (usertypeupdate) {
        updateuser.usertype = usertype;
        updateuser.userpermission = userpermission;
      }
      if (userviewupdate)
        updateuser.userview = userview;
      if (memv2versionupdate)
        updateuser.memv2version = memv2version;
      if (optionsupdate)
        updateuser.options = options;
      return (
        updateuser
      );
    });

    await axios
      .put(
        postUsers("update"),
        {
          users: updated,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Utilisateurs modifiés");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };
  const classes = useStyles();


  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={usertypeupdate}
                    handleSwitchChange={handleUsertypeupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={userpagetext.usertype}
                    selectValue={usertype}
                    handleSelectValueChange={handleUsertypeChange}
                    data={currentusertype == 1 ? usertypechangeadminData : usertypechangeadminmemData}
                    disabled={!usertypeupdate}
                  />
                </div>
                {
                  usertype === 0 ?
                    <div>
                      <CustomSelect
                        inputTitle={userpagetext.userpermission}
                        selectValue={userpermission}
                        handleSelectValueChange={handlePermissionChange}
                        data={permissionlist}
                        disabled={!usertypeupdate}
                      />
                    </div> : <></>
                }
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={userviewupdate}
                    handleSwitchChange={handleUserviewupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={userpagetext.userview}
                    selectValue={userview}
                    handleSelectValueChange={handleUserviewChange}
                    data={viewlist}
                    disabled={!userviewupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={memv2versionupdate}
                    handleSwitchChange={handleMemv2versionupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={userpagetext.memv2version}
                    selectValue={memv2version}
                    handleSelectValueChange={handleMemv2versionChange}
                    data={memv2versionData}
                    disabled={!memv2versionupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={optionsupdate}
                    handleSwitchChange={handleOptionsupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <AutocompleteMultiselectInputById
                    inputTitle={userpagetext.options}
                    selected={options}
                    list={optionsData}
                    handleChange={handleOptionsChange}
                    specialWidth={"94%"}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Enregistrer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditUsersDialog;
